// extracted by mini-css-extract-plugin
export default {"verify":"VerifyEmail_verify__C7GBj"};